export class ServicePath {
  public static readonly PRICING_SEARCH = "landing/v1/price";
  public static readonly RANGE_SUGGESTED_BENEFITS = "landing/v1/range-suggested-benefits";
  public static readonly BENEFITS_HISTORY = "landing/v1/benefit-history";
  public static readonly PRICE_HISTORY = "landing/v1/price-history";
}
